module.exports = {
      id: "prothomalo-com-usage",
      viewBox: "0 0 200 27",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#prothomalo-com",
      toString: function () {
        return this.url;
      }
    }